module.exports = __webpack_public_path__ + "images/CC_Add In Image Transparent_min.png";